import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProcessingSearchFormComponent } from './processing-search-form.component';
import { CardFormModule } from 'libraries/module/formbuilder/forms/card-form/card-form.module';
import { ButtonModule } from 'libraries/module/formbuilder/fields/button/button.module';
import { DateRangeModule } from 'libraries/module/formbuilder/fields/date-range/date-range.module';
import { MultiselectModule } from 'libraries/module/formbuilder/fields/multiselect/multiselect.module';
import { SearchUtilsService } from "app_sasha/shared/models/search-utils.service";
import { AfidiumServiceFieldModule } from "../afidium-service-field/afidium-service-field.module";


@NgModule({
    imports:      [
        CommonModule,
        CardFormModule,
        ButtonModule,
        DateRangeModule,
        MultiselectModule,
        AfidiumServiceFieldModule
    ],
    declarations: [
        ProcessingSearchFormComponent,
    ],
    exports: [
        ProcessingSearchFormComponent,
    ],
    providers: [
        SearchUtilsService,
    ]
})
export class ProcessingSearchFormModule {  }
